import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

// Office.js boot contract: never mount React before Office.onReady() resolves.
// Pre-Office.onReady, calls into Office.context throw — and any UI that
// depends on the loaded item would render in a broken state for a frame.
Office.onReady((info) => {
  if (info.host !== Office.HostType.Outlook) {
    document.getElementById('root')!.innerHTML =
      '<div class="p-6 text-sm">Deze add-in is alleen bruikbaar in Outlook.</div>';
    return;
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root mount point');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
